import React, { useEffect, useState } from 'react';
import List from '@mui/material/List';
import VerticalItem from './VerticalItem';
import NavVerticalGroup from './VerticalNavGroup';
import VerticalCollapse from './VerticalCollapse';
import { useAuthUser, useRoleUser } from '@crema/utility/AuthHooks';
import { adminRoutes, operatorRoutes, routesConfig, viewerRoutes, operatorEselon1Routes, penilaian360Routes, } from '../../../../../pages/routesConfig';

const VerticalNav = () => {
  const [menu, setMenu] = useState([])
  const { currentRole } = useRoleUser()
  // const { menu: menuList } = useAuthUser()

  // check currentRole dan set menu sesuai role
  useEffect(() => {
    let tmpMenu = []
    if (currentRole?.id === 'SIPEG_PEGAWAI') {
      tmpMenu = routesConfig
    } else if (currentRole?.id === 'SIPEG_ADMINISTRATOR') {
      tmpMenu = adminRoutes
    } else if (currentRole?.id === 'SIPEG_OPERATOR') {
      tmpMenu = operatorRoutes
    } else if (currentRole?.id === 'SIPEG_VIEWER') {
      tmpMenu = viewerRoutes
    } else if (currentRole?.id === 'SIPEG_OPERATOR_ESELON_1') {
      tmpMenu = operatorEselon1Routes
    } else if (currentRole?.id.includes('360')) {
      tmpMenu = penilaian360Routes
    }

    setMenu(tmpMenu)
  }, [currentRole])

  // useEffect(() => {
  //   if (menuList) {
  //     setMenu(menuList)
  //   }
  // }, [menuList])

  return (
    <List
      sx={{
        position: 'relative',
        padding: 0,
      }}
      component='div'
    >
      {(menu && menu.length) &&
        menu.map((item) => (
          <React.Fragment key={item.id}>
            {item.type === 'group' && <NavVerticalGroup item={item} level={1} />}

            {item.type === 'collapse' && (
              <VerticalCollapse item={item} level={1} />
            )}

            {(item.type === 'item' || item.type === 'nonGroup') && <VerticalItem item={item} level={1} />}
          </React.Fragment>
        ))
      }
    </List>
  );
};

export default VerticalNav;
